import { Checkbox } from '@mui/material';
import { useState } from 'react';
import { updateUserPermissions } from 'lib/firebase';

export interface ReadOnlyCellProps {
    updatedUserId?: string;
    currentUserId?: string | null;
    roleId?: number;
    readOnly?: boolean;
    isDisabled?: boolean;
}

export const ReadOnlyCell = ({
    currentUserId,
    updatedUserId,
    roleId,
    readOnly,
    isDisabled,
}: ReadOnlyCellProps) => {
    const [checked, setChecked] = useState(readOnly);
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);

        if (currentUserId && updatedUserId && roleId !== undefined) {
            updateUserPermissions(
                currentUserId,
                updatedUserId,
                event.target.checked, // readOnly value
                roleId
            );
        }
    };
    return (
        <div data-testid="ReadOnlyCell">
            <Checkbox
                checked={checked}
                onChange={onChange}
                disabled={isDisabled}
            />
        </div>
    );
};
